import React from 'react'
import BlogDetail from './BlogDetail';
import Header from '../Header'
import Footer from '../Footer'

export default function index() {
  return (
    <div>
      <Header/>
       <BlogDetail/> 
       <Footer/>
    </div>
  )
}
